<template>
  <div :class="$options.name">
    <v-toolbar dark color="blue darken-3" flat>
      <v-toolbar-title>Журнал синхронизаций</v-toolbar-title>

      <v-btn
        color="transparent"
        class="elevation-0 ml-2"
        title="Обновить журнал синхронизаций"
        @click="refreshList()"
      >
        <v-icon>refresh</v-icon>
      </v-btn>

      <div class="flex-grow-1" />

      <v-text-field
        v-model="searchQuery"
        label="Поиск по названию"
        prepend-inner-icon="search"
        hide-details
        single-line
        clearable
        flat
      />

      <v-btn
        color="success"
        class="elevation-0 ml-2"
        title="Импорт слоя"
        dark
        @click="toggleDialog('import-dialog')"
      >
        <v-icon>cloud_upload</v-icon>
      </v-btn>

      <v-btn
        v-if="showSyncButton"
        color="warning"
        class="elevation-0 ml-2"
        title="Синхронизировать слои"
        dark
        @click="toggleDialog('export-dialog')"
      >
        <v-icon>sync</v-icon>
      </v-btn>
    </v-toolbar>

    <v-data-table
      item-key="id"
      no-data-text="Нет данных"
      loading-text="Загрузка данных"
      class="elevation-0"
      hide-default-footer
      :headers="headers"
      :items="filteredList"
    >
      <template #item="{ item }">
        <TableItem
          :item="item"
          @download="downloadSyncData"
        />
      </template>
    </v-data-table>
    <v-pagination
      v-if="meta"
      :length="meta.last_page"
      :total-visible="8"
      :value="meta.current_page"
      :disabled="meta.last_page === 1"
      color="blue darken-3"
      class="pb-4 pt-4"
      @input="handleChangePage"
    />

    <import-sync-dialog
      v-if="isImportDialogOpen"
      :is-dialog-open="isImportDialogOpen"
      @closed="toggleDialog('import-dialog')"
      @add-import-file="addImportFile"
    />

    <export-layer-sync-dialog
      v-if="isExportDialogOpen"
      :is-dialog-open="isExportDialogOpen"
      @closed="toggleDialog('export-dialog')"
      @add-layers-sync="addLayersSync"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ImportSyncDialog from '@/components/dialogs/layers-sync-dialogs/ImportSyncDialog.vue';
import ExportLayerSyncDialog from '@/components/dialogs/layers-sync-dialogs/ExportLayerSyncDialog.vue';
import { downloadBlobFile } from '@/utils/download-file';
import isClosedHost from '@/utils/is-closed-host';

import TableItem from './TableItem.vue';

const INIT_HEADERS = [
  {
    value: 'layerObject.name',
    key: 'layerObject.name',
    text: 'Название слоя',
    sortable: true,
    skip: true,
  },
  {
    value: 'createdAt',
    key: 'createdAt',
    text: 'Дата создания',
    sortable: true,
    skip: true,
  },
  {
    value: 'status',
    key: 'status',
    text: 'Статус',
    sortable: true,
    skip: true,
  },
  // {
  //   value: 'progress',
  //   key: 'progress',
  //   text: 'Прогресс',
  //   sortable: false,
  // },
  {
    value: 'type',
    key: 'type',
    text: 'Тип',
    sortable: true,
    skip: true,
  },
  {
    value: 'errors',
    key: 'errors',
    text: 'Ошибки',
    sortable: false,
  },
  {
    value: 'id',
    key: 'id',
    sortable: false,
  },
];

export default {
  name: 'system-layers-sync',

  asyncData({ store }) {
    return store.dispatch('layersSync/getSyncsList');
  },

  components: {
    ImportSyncDialog,
    ExportLayerSyncDialog,
    TableItem,
  },

  data() {
    return {
      searchQuery: '',
      dialogs: {
        'import-dialog': {
          isOpen: false,
        },
        'export-dialog': {
          isOpen: false,
        },
      },
    };
  },

  computed: {
    ...mapState('layersSync', ['syncsList', 'meta']),

    isImportDialogOpen() {
      return this.dialogs['import-dialog'].isOpen;
    },

    isExportDialogOpen() {
      return this.dialogs['export-dialog'].isOpen;
    },

    filteredList() {
      if (this.searchQuery) {
        return this.syncsList.filter(item => item.layerObject.name
          .toLowerCase().indexOf(this.searchQuery?.toLowerCase()) !== -1);
      }
      return this.syncsList;
    },
    showSyncButton() {
      return isClosedHost();
    },
  },

  created() {
    this.headers = INIT_HEADERS;
  },

  methods: {
    ...mapActions('layersSync', ['getSyncsList', 'syncLayers', 'getSyncData', 'importLayer']),

    refreshList() {
      this.getSyncsList();
    },

    toggleDialog(type) {
      this.dialogs[type].isOpen = !this.dialogs[type].isOpen;
    },

    addLayersSync(layersForSync) {
      this.syncLayers({ layerIds: [...layersForSync] });
      this.toggleDialog('export-dialog');
    },

    async downloadSyncData(id) {
      const file = await this.getSyncData(id);

      if (file) {
        downloadBlobFile(file, 'sync-data.json');
      }
    },

    handleChangePage(page) {
      this.getSyncsList({ page });
    },

    addImportFile(file) {
      this.importLayer(file);
      this.toggleDialog('import-dialog');
    },
  },
};
</script>
